<vi-card>
  <div title class="title">
    <h2 data-at-title>{{ data.tileType | dashboardTileName }}</h2>
    <mat-icon (click)="closeDialog()" class="close-icon">close</mat-icon>
  </div>
  <div body data-at-body class="flex-col content-body">
    <hr />
    <app-dashboard-tile-installation-list
      [tileType]="data.tileType"
      [virtualScrollEnabled]="true"
      (navigateEvent)="closeDialog()"
    >
    </app-dashboard-tile-installation-list>
  </div>
  <div footer class="footer">
    <app-tile-modal-footer-actions
      [tileType]="data.tileType"
      (closeDialog)="closeDialog()"
    ></app-tile-modal-footer-actions>
  </div>
</vi-card>
